
import { Spinner } from 'construct-ui';
import SingleSelectCommonComponentView from '../../../components/common/single-select-common-component.view';
import { messageComponent } from '../../../components/message/message.component';
import SingleSelectComponent from '../../../components/single-select/single-select.component';
import loginModel from '../../../models/login.model';
import workTemplateModel from '../../../models/schedule/work-template.modal';
import ViewBase from '../../view-base.view';
import WorkTemplateTimePickerView from './work-template-hour-min-picker.view';

export default function WorkTemplateAddEditView() { // [CV]: function name and JS filename not matched! --> [JinZhang:2025-11-12] filename changed
    ViewBase.call(this);

    let onAddClose = (e) => { }
    let onSaveComplete = (e) => { }

    let ddlSpecialTask = {
        code: "", name: ""
    }

    let ddlDayOff = {
        code: "", name: ""
    }

    let ddlLeaveType = {
        code: "", name: ""
    }

    let ddlWorkType = {
        code: "", name: ""
    }

    let ddlStartTimeHour = {
        code: "", name: ""
    }

    let ddlStartTimeMin = {
        code: "", name: ""
    }

    let ddlEndTimeHour = {
        code: "", name: ""
    }

    let ddlEndTimeMin = {
        code: "", name: ""
    }

    let ddlBreakTimeHour = {
        code: "", name: ""
    }

    let ddlBreakTimemin = {
        code: "", name: ""
    }

    let isEditable = true;
    let isLoading = false;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";

    let inputDataModel = {
        breakHourDisabled: true,
        name: "",
        workType: "",
        startTime_hour: "",
        startTime_min: "",
        endTime_hour: "",
        endTime_min: "",
        breakHour: "",
        breakMin: "",
        permission: "",
        periodDisabled: false,
        sequence: "",
        remarks: "",
        colorCode: "",
        workTypeList: [],
        selectedWorkType: "",
        colorList: [],
        leaveTypeList: [],
        leaveType: "",
        dayoffTypeList: [],
        dayOffType: "",
        masterId: "0",
        specialTaskTypeList: [],
        specialTaskType: ""
    }

    let _getName = (e) => {
        inputDataModel.name = e.target.value;
    }

    let _getSequence = (e) => {
        inputDataModel.sequence = e.target.value;
    }

    let _getRemarks = (e) => {
        inputDataModel.remarks = e.target.value;
    }

    let _loadDayOffList = () => {
        workTemplateModel.getDayoffList(
            (result) => {
                inputDataModel.dayoffTypeList = result;
            },
            (error) => {
                isMsgOpen = true;
                showMsg = error.response[0].transStatus;
                msgTitle = this.getText(error.response[0].code);
            }
        )
    }

    let _loadLeaveTypeList = () => {
        workTemplateModel.getLeaveTypeList(
            (result) => {
                inputDataModel.leaveTypeList = result;
            },
            (error) => {
                isMsgOpen = true;
                showMsg = error.response[0].transStatus;
                msgTitle = this.getText(error.response[0].code);
            }
        )
    }

    let _loadSpecialTaskTypeList = () => {
        workTemplateModel.getSpecIalTaskTypeList()
            .then((result) => {
                inputDataModel.specialTaskTypeList = result;
            })
            .catch((error) => {
                this.handleError(error);
            });;
    }

    let _save = () => {
        let error = _isValid();
        if (error == "") {
            let subType = "";
            switch (ddlWorkType.code) {
                case "002":
                    subType = ddlLeaveType.code;
                    break;
                case "003":
                    subType = ddlDayOff.code;
                    break;
                case "007":
                    subType = ddlSpecialTask.code;
                    break;
                default:
                    break;
            }

            let saveobj = {
                workType: ddlWorkType.code,
                workTemplateName: inputDataModel.name,
                startTime: inputDataModel.periodDisabled ? "" : ddlStartTimeHour.name + ":" + ddlStartTimeMin.name,
                endTime: inputDataModel.periodDisabled ? "" : ddlEndTimeHour.name + ":" + ddlEndTimeMin.name,
                timeRequiredYN: !inputDataModel.periodDisabled ? "Y" : "N",
                breakHour: inputDataModel.breakHourDisabled ? "" : ddlBreakTimeHour.name + ":" + ddlBreakTimemin.name,
                breakHourRequiredYN: !inputDataModel.breakHourDisabled ? "Y" : "N",
                leaveDayOffType: subType,
                permission: inputDataModel.permission,
                sequence: inputDataModel.sequence,
                remarks: inputDataModel.remarks,
                colorCode: inputDataModel.colorCode
            };

            if (inputDataModel.masterId == "0") {
                workTemplateModel.saveWorkTemplate(
                    (result) => {
                        onSaveComplete(result);
                    },
                    (error) => {
                        isMsgOpen = true;
                        showMsg = error.response[0].transStatus;
                        msgTitle = this.getText(error.response[0].code);

                    },
                    saveobj
                )
            } else {
                saveobj["status"] = "001";
                workTemplateModel.updateWorkTypeList(
                    (result) => {
                        onSaveComplete(result);
                    },
                    (error) => {
                        isMsgOpen = true;
                        showMsg = error.response[0].transStatus;
                        msgTitle = this.getText(error.response[0].code);

                    },
                    saveobj, inputDataModel.masterId
                )
            }
        } else {
            isMsgOpen = true;
            showMsg = error;
            msgTitle = this.getText("EM00000142", "Error");
        }
    }

    let _isValid = () => {
        let error = "";
        if (ddlWorkType.code != "") {
            if (inputDataModel.name == "") {
                error = this.getText("EM00000254", "Name cannot be null");
                return error;
            }

            if (inputDataModel.sequence == "") {
                error = this.getText("EM00000255", "Sequence cannot be null");
                return error;
            }

            if (inputDataModel.permission == "") {
                error = this.getText("EM00000256", "Permission cannot be null");
                return error;
            }

            if (ddlWorkType.code == "001") {
                if (ddlStartTimeHour.code == "" || ddlStartTimeMin.code == "" || ddlEndTimeHour.code == "" || ddlEndTimeMin.code == "") {
                    error = this.getText("EM00000259", "Invalid period selection");
                    return error;
                }
                if (!inputDataModel.breakHourDisabled && (ddlBreakTimeHour.code == "" || ddlBreakTimemin.code == "")) {
                    error = this.getText("EM00000260", "Invalid break hour selection");
                    return error;
                }
            }

            if (ddlWorkType.code == "002") {
                if (ddlLeaveType.code == "") {
                    error = this.getText("EM00000235", "Please select a leave type");
                    return error;
                }
            }

            if (ddlWorkType.code == "003") {
                if (ddlDayOff.code == "") {
                    error = this.getText("EM00000239", "Please select a Day-Off type");
                    return error;
                }
            }

            if (ddlWorkType.code == "004" || ddlWorkType.code == "005" || ddlWorkType.code == "007") {
                if (!inputDataModel.periodDisabled && (ddlStartTimeHour.code == "" || ddlStartTimeMin.code == "" || ddlEndTimeHour.code == "" || ddlEndTimeMin.code == "")) {
                    error = this.getText("EM00000259", "Invalid period selection");
                    return error;
                }
            }

            if (ddlWorkType.code == "006") {//others
                if (inputDataModel.remarks == "") {
                    error = this.getText("EM00000263", "remarks cannot be null");
                    return error;
                }
            }

            if (ddlWorkType.code == "007") {
                if (ddlSpecialTask.code == "") {
                    error = this.getText("EM00000845", "Please select a Special Task type");
                    return error;
                }
            }
        } else {
            error = this.getText("EM00000258", "Please select a work type");
            return error;

        }
        return error;
    }

    let _cancel = () => {
        onAddClose();
    }

    let _dialogClosed = () => {
        isMsgOpen = false;

    }

    let _handleWorkTypeChange = (selectedItem) => {
        ddlWorkType = selectedItem;
        ddlStartTimeHour = { code: "", name: "" };
        ddlStartTimeMin = { code: "", name: "" };
        ddlEndTimeHour = { code: "", name: "" };
        ddlEndTimeMin = { code: "", name: "" };
        ddlBreakTimeHour = { code: "", name: "" };
        ddlBreakTimemin = { code: "", name: "" };
        inputDataModel.colorCode = selectedItem.code;

        if (ddlWorkType.code == "001") {
            inputDataModel.periodDisabled = false;
            inputDataModel.breakHourDisabled = true;
        } else if (ddlWorkType.code == "002" || ddlWorkType.code == "003" || ddlWorkType.code == "004" || ddlWorkType.code == "005" || ddlWorkType.code == "006") {
            inputDataModel.periodDisabled = true;
            inputDataModel.breakHourDisabled = true;

            if (ddlWorkType.code == "002") {
                _loadLeaveTypeList();
            }

            if (ddlWorkType.code == "003") {
                _loadDayOffList();
            }
        } else if (ddlWorkType.code == "007") {
            inputDataModel.periodDisabled = true;
            _loadSpecialTaskTypeList();
        }
    }

    let _getWorkTemplateById = () => {
        isLoading = true;
        workTemplateModel.getWorkTemplateDetail(
            (result) => {
                isLoading = false;
                _loadDetals(result);
            },
            (error) => {
                isLoading = false;
                isMsgOpen = true;
                showMsg = error.response[0].transStatus;
                msgTitle = this.getText(error.response[0].code);
            },
            inputDataModel.masterId
        )
    }

    let _loadDetals = (details) => {
        let response = details[0];
        ddlWorkType = { code: response.workType, name: response.workTypeName };
        inputDataModel.name = response.workTemplateName;
        inputDataModel.colorCode = response.colorCode;
        inputDataModel.sequence = response.sequence;
        inputDataModel.permission = response.permission;
        inputDataModel.periodDisabled = response.timeRequiredYN == "N" ? true : false;
        inputDataModel.breakHourDisabled = response.breakHourRequiredYN == "N" ? true : false;
        inputDataModel.remarks = response.remarks;
        if (response.workType == "002") {
            _loadLeaveTypeList();
            ddlLeaveType = { code: response.leaveDayOffType, name: response.leaveDayOffName };
        }
        if (response.workType == "003") {
            _loadDayOffList();
            ddlDayOff = { code: response.leaveDayOffType, name: response.leaveDayOffName };
        }
        if (response.workType == "007") {
            _loadSpecialTaskTypeList();
            ddlSpecialTask = { code: response.leaveDayOffType, name: response.leaveDayOffName };
        }
        if (inputDataModel.periodDisabled) {
            ddlStartTimeHour = { code: "", name: "" };
            ddlStartTimeMin = { code: "", name: "" };
            ddlEndTimeHour = { code: "", name: "" };
            ddlEndTimeMin = { code: "", name: "" };
        } else {
            let stArr = response.startTime.split(':');
            let enArr = response.endTime.split(':');
            ddlStartTimeHour = { code: stArr[0], name: stArr[0] };
            ddlStartTimeMin = { code: stArr[1], name: stArr[1] };
            ddlEndTimeHour = { code: enArr[0], name: enArr[0] };
            ddlEndTimeMin = { code: enArr[1], name: enArr[1] };
        }
        if (inputDataModel.breakHourDisabled) {

            ddlBreakTimeHour = { code: "", name: "" };
            ddlBreakTimemin = { code: "", name: "" };
        } else {
            let brArr = response.startTime.split(':');
            ddlBreakTimeHour = { code: brArr[0], name: brArr[0] };
            ddlBreakTimemin = { code: brArr[1], name: brArr[1] };
        }
        if (!loginModel.credentials.admin && inputDataModel.permission == "001") {
            isEditable = false;
            inputDataModel.periodDisabled = true;
            inputDataModel.breakHourDisabled = true;
        }
    }

    return {

        oninit: function (vnode) {
            if (vnode.attrs.onAddClose) {
                onAddClose = vnode.attrs.onAddClose;
            }
            if (vnode.attrs.onSaveComplete) {
                onSaveComplete = vnode.attrs.onSaveComplete;
            }
            if (vnode.attrs.masterId) {
                inputDataModel.masterId = vnode.attrs.masterId;
                if (inputDataModel.masterId != "0") {
                    _getWorkTemplateById();
                }
            }
        },
        view: (vnode) => {
            let wtList = vnode.attrs.workTypeList.filter(x => x.code != "");
            return [
                m('.row', m(Spinner, {
                    active: isLoading,
                    background: true,
                    fill: true,
                    size: 'xl',
                }),
                    m('col-md-12',
                        m('.w-100',
                            m('h2.mb-3',
                                m('i.bi.bi-arrow-left.cursor-pointer', { onclick: _cancel }),
                                this.getText("LT00000146", "Work Template - List")
                            )
                        ),
                        m('.card',
                            m('.card-body',
                                m('.row.col-md-12',
                                    m('.col-md-6.mt-4',
                                        m('label.form-label', this.getText("LT00000011", "Name"),
                                            m('span.redText', "*")
                                        ),
                                        m('input[type=text][placeholder=' + this.getText("LT00000011", "Name") + '][maxLength="200"][value="' + inputDataModel.name + '"].form-control.form-control-bg',
                                            {
                                                disabled: !isEditable,
                                                onchange: _getName
                                            }
                                        )
                                    ),
                                    m('.col-md-6.mt-4',
                                        m('label.form-label', this.getText("LT00000149", "Work Type"),
                                            m('span.redText', "*")
                                        ),
                                        m(SingleSelectCommonComponentView, {
                                            disabled: inputDataModel.masterId == "0" ? false : true, iconList: vnode.attrs.iconList, items: wtList, selectedItem: ddlWorkType, handleSelect: (selectedItem) => {
                                                _handleWorkTypeChange(selectedItem);
                                            }
                                        })
                                    ),
                                ),
                                m('.row.col-md-12.mt-2', m('hr')),
                                ddlWorkType.code == "007" && m('.row.col-md-12.mt-2',//only for Special Task
                                    m('.col-md-3',
                                        m('label.form-label', this.getText("LT00001340", "Special Task Type"),
                                            m('span.redText', "*")
                                        ),
                                        m(SingleSelectComponent, {
                                            id: "specialTaskType",
                                            items: inputDataModel.specialTaskTypeList,
                                            selectedItem: ddlSpecialTask,
                                            onSelect: (s) => { ddlSpecialTask = s },
                                            allowEmpty: false,
                                        })
                                    ),
                                ),
                                (ddlWorkType.code == "001" || ddlWorkType.code == "004" || ddlWorkType.code == "005" || ddlWorkType.code == "007") && m('.row.col-md-12.mt-2',
                                    m('label.form-label', this.getText("LT00000150", "Period"),
                                        ddlWorkType.code == "001" && m('span.redText', "*")
                                    ),
                                    m('.col-md-2',
                                        m(WorkTemplateTimePickerView, {
                                            pickerType: "hour", onChanged: (selectedItem) => {
                                                ddlStartTimeHour = selectedItem;
                                            }, disabled: inputDataModel.periodDisabled, selectedItem: ddlStartTimeHour
                                        })
                                    ),
                                    m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', ":")),
                                    m('.col-md-2',
                                        m(WorkTemplateTimePickerView, {
                                            pickerType: "min", onChanged: (selectedItem) => {
                                                ddlStartTimeMin = selectedItem;
                                            }, disabled: inputDataModel.periodDisabled, selectedItem: ddlStartTimeMin
                                        })
                                    ),
                                    m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', "~")),
                                    m('.col-md-2',
                                        m(WorkTemplateTimePickerView, {
                                            pickerType: "hour", onChanged: (selectedItem) => {
                                                ddlEndTimeHour = selectedItem;
                                            }, disabled: inputDataModel.periodDisabled, selectedItem: ddlEndTimeHour
                                        })
                                    ),
                                    m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', ":")),
                                    m('.col-md-2',
                                        m(WorkTemplateTimePickerView, {
                                            pickerType: "min", onChanged: (selectedItem) => {
                                                ddlEndTimeMin = selectedItem;
                                            }, disabled: inputDataModel.periodDisabled, selectedItem: ddlEndTimeMin
                                        })
                                    ),
                                    (ddlWorkType.code == "004" || ddlWorkType.code == "005" || ddlWorkType.code == "007") && m('.col-md-1.mt-2',
                                        m('input[type="checkbox"].form-check-input#periodNA',
                                            {
                                                style: "margin-right:7px",
                                                disabled: !isEditable,
                                                checked: inputDataModel.periodDisabled,
                                                onclick: (e) => {
                                                    ddlStartTimeHour = { code: "", name: "" };
                                                    ddlStartTimeMin = { code: "", name: "" };
                                                    ddlEndTimeHour = { code: "", name: "" };
                                                    ddlEndTimeMin = { code: "", name: "" };
                                                    inputDataModel.periodDisabled = e.target.checked;
                                                }
                                            }
                                        ), m('label[for="periodNA"]', "N/A")
                                    ),

                                ),
                                ddlWorkType.code == "001" && m('.row.col-md-12.mt-2',
                                    m('label.form-label', this.getText("LT00000151", "break Hour"),
                                        m('span.redText', "*")
                                    ),
                                    m('.col-md-2',
                                        m(WorkTemplateTimePickerView, {
                                            pickerType: "hour", onChanged: (selectedItem) => {
                                                ddlBreakTimeHour = selectedItem;
                                            }, disabled: inputDataModel.breakHourDisabled, selectedItem: ddlBreakTimeHour
                                        })
                                    ),
                                    m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', ":")),
                                    m('.col-md-2',
                                        m(WorkTemplateTimePickerView, {
                                            pickerType: "min", onChanged: (selectedItem) => {
                                                ddlBreakTimemin = selectedItem;
                                            }, disabled: inputDataModel.breakHourDisabled, selectedItem: ddlBreakTimemin
                                        })
                                    ),
                                    m('.col-md-2.mt-2',
                                        m('input[type="checkbox"].form-check-input',
                                            {
                                                style: "margin-right:7px",
                                                disabled: !isEditable,
                                                checked: inputDataModel.breakHourDisabled,
                                                onclick: (e) => {
                                                    ddlBreakTimeHour = { code: "", name: "" };
                                                    ddlBreakTimemin = { code: "", name: "" };
                                                    inputDataModel.breakHourDisabled = e.target.checked;
                                                }
                                            }
                                        ),
                                        m('span', "N/A")
                                    ),

                                ),
                                ddlWorkType.code == "002" && m('.row.col-md-12.mt-2',
                                    m('.col-md-3',
                                        m('label.form-label', this.getText("LT00000160", "Leave Type"),
                                            m('span.redText', "*")
                                        ),
                                        m(SingleSelectCommonComponentView, {
                                            disabled: !isEditable,
                                            iconList: [], items: inputDataModel.leaveTypeList, selectedItem: ddlLeaveType, handleSelect: (selectedItem) => {
                                                ddlLeaveType = selectedItem;
                                            }
                                        })
                                    ),
                                ),
                                ddlWorkType.code == "003" && m('.row.col-md-12.mt-2',//only for Dayoff
                                    m('.col-md-3',
                                        m('label.form-label', this.getText("LT00000161", "Day off Type"),
                                            m('span.redText', "*")
                                        ),
                                        m(SingleSelectCommonComponentView, {
                                            disabled: !isEditable,
                                            iconList: [], items: inputDataModel.dayoffTypeList, selectedItem: ddlDayOff, handleSelect: (selectedItem) => {
                                                ddlDayOff = selectedItem;
                                            }
                                        })
                                    ),
                                ),
                                ddlWorkType.code != "" && m('.row.col-md-12.mt-2',
                                    m('.col-md-4',
                                        m('.col-md-12', m('label', this.getText("LT00000079", "Permission")), m('span.redText', "*")),
                                        m('.col-md-12.row',
                                            m('.col-md-6',
                                                m('.form-check.form-check-inline',

                                                    m('input.form-check-input[type="radio"][name="radioType"]#permissionPublic',
                                                        {
                                                            disabled: !loginModel.credentials.admin,
                                                            checked: inputDataModel.permission == "001",
                                                            onclick: (e) => {
                                                                inputDataModel.permission = "001"
                                                            }
                                                        }
                                                    ),
                                                    m('label.form-check-label[for="permissionPublic"]', this.getText("LT00000083", "Public"))
                                                )
                                            ),
                                            m('.col-md-6',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]#permissionPersonal',
                                                        {
                                                            disabled: !isEditable,
                                                            checked: inputDataModel.permission == "002",
                                                            onclick: (e) => {
                                                                inputDataModel.permission = "002"
                                                            }
                                                        }
                                                    ),
                                                    m('label.form-check-label[for="permissionPersonal"]', this.getText("LT00000084", "Personal"))
                                                )
                                            ),
                                        ),

                                    )),
                                ddlWorkType.code != "" && m('.row.col-md-12.mt-2',
                                    m('.col-md-3',
                                        m('label.form-label', this.getText("LT00000148", "Display Seq"),
                                            m('span.redText', "*")
                                        ),
                                        m('input[type="number"][min="0"][placeholder=' + this.getText("LT00000148", "Display Seq") + '][value="' + inputDataModel.sequence + '"].form-control.form-control-bg',
                                            {
                                                disabled: !isEditable,
                                                onchange: _getSequence
                                            }
                                        )
                                    ),
                                ),
                                (ddlWorkType.code != "" && ddlWorkType.code != "002" && ddlWorkType.code != "003") && m('.row.col-md-12',
                                    m('.col-md-10.mt-2',
                                        m('label.form-label',
                                            ddlWorkType.code == "001" && this.getText("LT00000152", "Remarks"),
                                            ddlWorkType.code == "004" && this.getText("LT00000162", "Remarks/Place"),
                                            ddlWorkType.code == "006" && this.getText("LT00000163", "Remarks(Place/Schedule)"), ddlWorkType.code == "006" && m('span.redText', "*"),
                                            ddlWorkType.code == "005" && this.getText("LT00000162", "Remarks/Place"),
                                        ),
                                        m('textarea[placeholder=' + this.getText("LT00000152", "Remarks") + '][value="' + inputDataModel.remarks + '"].form-control.form-control-bg',
                                            {
                                                disabled: !isEditable,
                                                onchange: _getRemarks
                                            }
                                        )
                                    )
                                ),
                            ),
                            m('.card-footer',
                                m('.col-md-12 .gap-2 .d-flex .justify-content-end',
                                    isEditable && m(
                                        "button.btn.btn-primary[type='button']", { onclick: _save },
                                        this.getText("LT00000022", "Save")
                                    ),
                                    m(
                                        "button.btn.btn-white[type='button']", { onclick: _cancel },
                                        this.getText("LT00000021", "Close")
                                    )
                                )
                            )
                        )
                    ),
                ),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
                this.getBaseViews()
            ];
        }
    }
}
